import { HTMLProps, ReactNode } from "react";
import CorePaper, { CorePaperProps } from "../paper";
import { Typography, TypographyProps } from "@mui/material";
import styles from "./TitleCard.module.css";

export type CoreTitleCardProps = {
	title?: ReactNode;
	description?: ReactNode;
	rightContent?: ReactNode;
	topContent?: ReactNode;
	slotProps?: { text?: HTMLProps<HTMLDivElement>; title?: TypographyProps; description?: TypographyProps };
} & Omit<CorePaperProps, "children" | "title">;

export function CoreTitleCardHeader({ sx, children, ...typographyProps }: TypographyProps) {
	return (
		<Typography {...typographyProps} sx={{ fontSize: 20, fontWeight: 600, textAlign: "start", ...sx }}>
			{children}
		</Typography>
	);
}

export function CoreTitleCardDescription({ children, className, ...typographyProps }: TypographyProps) {
	return (
		<Typography {...typographyProps} className={`${styles.description} ${className || ""}`}>
			{children}
		</Typography>
	);
}

export default function CoreTitleCard({
	title,
	description,
	rightContent,
	topContent,
	className,
	slotProps,
	...paperProps
}: CoreTitleCardProps) {
	return (
		<CorePaper {...paperProps} className={`${styles.header} ${className || ""}`} component="header">
			<div {...slotProps?.text} className={`${styles.headerInfo} ${slotProps?.text?.className || ""}`}>
				{topContent}
				{title && (
					<CoreTitleCardHeader variant="h1" {...slotProps?.title}>
						{title}
					</CoreTitleCardHeader>
				)}
				{description && <CoreTitleCardDescription {...slotProps?.description}>{description}</CoreTitleCardDescription>}
			</div>
			{rightContent}
		</CorePaper>
	);
}
